import {
  makeStyles,
  mergeClasses,
  SearchBoxChangeEvent,
} from "@fluentui/react-components";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { $cloud50 } from "../../cssjs/colors";
import PageEnum from "../../enum/PageEnum";
import { getAirportConfig } from "../../utils/common/CommonHelperFunctions";
import { findMatches } from "../../utils/multi-airports/MultiAirportHelperFunctions";
import MapDisplayFlights from "../map-libre/map-displays/MapDisplayFlights";
import { OverviewSidebar } from "../overview-sidebar/OverviewSidebar";
import { FlightCard } from "../shared/components/airport-cards/FlightCard";
import { OverviewKPICard } from "../shared/components/airport-cards/overviewKPI/OverviewKpiCard";
import { PaxCard } from "../shared/components/airport-cards/PaxCard";
import { WeatherCard } from "../shared/components/airport-cards/WeatherCard";
import PaxSecurity from "./overview-cards/pax-security/PaxSecurity";
import ResourceAvailability from "./overview-cards/resources-availability/ResourceAvailability";

interface IOverviewYQBProps {
  airport: string;
}

export const OverviewYQB: React.FC<IOverviewYQBProps> = ({ airport }) => {
  const classes = useStyles();
  const airportConfig = getAirportConfig(airport);
  const [sideBarActive, setSideBarActive] = useState<boolean>(true);

  function searchInputHandler(event: SearchBoxChangeEvent): void {
    const { target } = event;
    const { value } = target as HTMLInputElement;
    findMatches(value, []);
  }

  return (
    <>
      <section className="card1" data-testid="weatherCard">
        <Link
          to={`/${PageEnum.PageUrl.Weather}`}
          style={{ textDecoration: "none" }}
        >
          <WeatherCard />
        </Link>
      </section>

      <section className="card2" data-testid="flightCard">
        <Link
          to={`/${PageEnum.PageUrl.Flights}`}
          style={{ textDecoration: "none" }}
        >
          <FlightCard airportCode={airport} />
        </Link>
      </section>

      <ResourceAvailability airport={airport} />

      <section className="card3" data-testid="paxCard">
        <PaxCard airport={airport} />
      </section>

      <PaxSecurity airport={airport} />

      <OverviewKPICard airportCode={airport} />

      {/* Map View */}
      <section
        className={mergeClasses(classes.mapViewContainer, "map")}
        data-testid="mapViewContainer"
        style={{ gridColumn: "1 / -1" }}
      >
        <OverviewSidebar
          sideBarActive={sideBarActive}
          setSideBarActive={setSideBarActive}
          searchInputHandler={searchInputHandler}
          airportCode={airport}
        />
        <MapDisplayFlights
          airportMapDetail={{
            id: airportConfig.iataCode,
            code: airportConfig.iataCode,
            name: airportConfig.name,
            location: airportConfig.location as [number, number],
          }}
          setSideBarActive={setSideBarActive}
        />
      </section>
    </>
  );
};

const useStyles = makeStyles({
  mapViewContainer: {
    position: "relative",
    background: "#F8F8F8",
    paddingTop: "8px",
    borderRadius: "8px",
    border: `1px solid ${$cloud50}`,
    "&.map": {
      minHeight: "825px",
    },
  },
});
